module.exports = __webpack_public_path__ + "img/道乐科技icon.007732d6.svg";